import { useState } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  List,
  ListItem,
  ListItemText,
  TextField,
  Typography,
} from "@material-ui/core";
import Btn from "../../../../components/buttons/Btn";
import moment from "moment";
import { InsertEmoticon } from "@material-ui/icons";

const ModalOpenFinanceRetroactive = ({
  accountId,
  open = false,
  handleClose = () => {},
  handleOpenFinanceRetroactive = () => {},
}) => {
  const [selectedStartDate, setSelectedStartDate] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState(
    moment().format("YYYY-MM-DD")
  );

  const [validDates, setValidDates] = useState(false);

  const validateDates = (overrides = {}) => {
    const start = overrides.start ?? moment(selectedStartDate);
    const end = overrides.end ?? moment(selectedEndDate);

    if (!start.isValid() || !end.isValid()) {
      setValidDates(false);
      return;
    }

    const today = moment();
    const minStart = today.clone().subtract(90, "days").startOf("day");

    setValidDates(
      !start.isAfter(end, "day") &&
        start.isSameOrAfter(minStart, "day") &&
        !end.isAfter(today, "day")
    );
  };

  const handleStartDateChange = (e) => {
    const value = e.target.value;
    const date = moment(value);
    setSelectedStartDate(value);
    validateDates({ start: date, end: moment(selectedEndDate) });
  };

  const handleEndDateChange = (e) => {
    const value = e.target.value;
    const date = moment(value);
    setSelectedEndDate(value);
    validateDates({ start: moment(selectedStartDate), end: date });
  };

  const handleConfirm = () => {
    if (validDates) {
      console.log(selectedStartDate, selectedEndDate);
      handleOpenFinanceRetroactive({ startDate: selectedStartDate, endDate: selectedEndDate });
    }
  };

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle> Dicas para a Busca Retroativa </DialogTitle>

      <DialogContent>
        <Grid container justifyContent="space-around" spacing={2}>
          <Grid item xs={12}>
<Box sx={{ p: 2, bgcolor: 'background.paper', borderRadius: 1 }}>
  <List dense>
    <ListItem disableGutters>
      <ListItemText 
        primary="Quando utilizar?" 
        secondary="Recomendado para sua configuração inicial ou para trazer lançamentos que não aparecem no extrato." 
      />
    </ListItem>

    <ListItem disableGutters>
      <ListItemText 
        primary="Qual o período máximo?" 
        secondary={
          <>
            Você pode buscar movimentações de até <strong>90 dias</strong>. Para períodos maiores, entre em contato com nosso suporte.
          </>
        } 
      />
    </ListItem>

    <ListItem disableGutters>
      <ListItemText 
        primary="Cuidado com duplicados" 
        secondary="Evite buscar datas que você já conciliou manualmente através de arquivos OFX." 
      />
    </ListItem>

    <ListItem disableGutters>
      <ListItemText 
        primary="Tempo de processamento" 
        secondary="Isso pode levar alguns minutos. Enquanto isso, o sistema trabalha de forma automática para você." 
      />
    </ListItem>
  </List>
</Box>
          </Grid>
          <Grid item xs={12}>
            <Box mb={2} />
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Data de início"
                  type="date"
                  variant="outlined"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={selectedStartDate}
                  onChange={handleStartDateChange}
                  inputProps={{
                    max: moment().format("YYYY-MM-DD"),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Data de fim"
                  type="date"
                  variant="outlined"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={selectedEndDate}
                  onChange={handleEndDateChange}
                  inputProps={{
                    max: moment().format("YYYY-MM-DD"),
                    min: selectedStartDate,
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Btn onClick={handleClose} bgcolor="red" label="Fechar" />
        <Btn
          onClick={handleConfirm}
          bgcolor="tertiary"
          label="Buscar"
          disabled={!validDates}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalOpenFinanceRetroactive;
